"use client";

import { useState } from "react";
import { LoadingSpinner } from "@/components/LoadingState";
import useMediaImageSource from "@/hooks/useMediaImageSource";

export default function MediaImage({ item, className, style, draggable = false }) {
  const { src, loading } = useMediaImageSource(item);
  const [failedSrc, setFailedSrc] = useState(null);
  if (loading || !src || failedSrc === src) {
    return <span role="status" aria-label={loading ? "Loading image" : undefined} className="flex min-h-40 w-full items-center justify-center p-4 text-sm" style={style}>{loading ? <LoadingSpinner /> : "Image unavailable"}</span>;
  }
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} alt={item.alt || ""} className={className} style={style} draggable={draggable} onError={() => setFailedSrc(src)} />;
}
